import { Component } from '@verndale/core';
import GenericAccordion from './generic-accordion';
import { constEvent } from '../utils/constants';

class Module extends Component {
  setupDefaults() {
    this.isinitializedClass = 'initialized';
    this.itemShowClass = 'generic-accordion__item--show';
  }

  addListeners() {
    document._on(constEvent.COVEO_RESULTS_UPDATED, this.init(this));
  }

  updateDisplayClasses() {
    let maxItems = this.el.dataset.maxItems || '0';
    const $allItems = this.el._$$('.generic-accordion__item');

    maxItems = window.parseInt(maxItems, 10);

    $allItems.forEach((el, i) => {
      if (i < maxItems-1) {
        el.classList.add(this.itemShowClass);
      } else {
        el.classList.remove(this.itemShowClass);
      }
    });
  }

  init() {
    if (this.el.classList.contains(this.isinitializedClass)) return;

    if (this.el._$$('.generic-accordion__item').length) {
      this.el.classList.add(this.isinitializedClass);
      this.updateDisplayClasses();
      new GenericAccordion(this.el);
    } else {
      setTimeout(() => {
        this.init();
      }, 1000);
    }
  }
}

export default Module;
